import { type ReactNode, useCallback } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Button, ButtonTypeEnum } from "@b2bportal/core-ui";
import clsx from "clsx";
import defaultStyles from "./Card.module.scss";

type CardProps = {
  children: ReactNode;
  className?: string;
  spacing?: "none" | "medium" | "large";
  onClick?: () => void;
} & React.HTMLAttributes<HTMLButtonElement>;

export const Card = ({
  children,
  className,
  spacing = "medium",
  onClick,
  ...rest
}: CardProps) => {
  const [block, cn] = useModuleBEM(defaultStyles, "Card");

  const onClickInternal = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick?.();
    },
    [onClick]
  );

  return (
    <Button
      buttonType={ButtonTypeEnum.Wrap}
      onClick={onClick && onClickInternal}
      className={clsx(
        block,
        className,
        spacing !== "medium" && cn(spacing),
        !onClick && cn("non-clickable")
      )}
      {...rest}
    >
      {children}
    </Button>
  );
};
